import React, { useState, useEffect } from "react";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import { Row, Col } from "react-bootstrap";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import Button from "../../../components/shared/buttons/button";
import {
  useCreateSupplierMutation,
  useUpdateSupplierMutation,
} from "./supplierApi";
import SelectBox from "../../../components/shared/fields/SelectBox ";
import { useGetRolesQuery } from "../../../app/globalApi";
import { capitalize, getCurrentDateTime, convertToUserTimezone} from "../../../helpers/Utils";
import useTranslator from "../../../hooks/useTranslator";
import { validatePhoneNumber } from "../../../helpers/phoneValidation";

const SupplierModal = ({ show, setShow, supplier, mode }) => {
  const { _t } = useTranslator();
  const [createSupplier, { isLoading: isCreating }] =
    useCreateSupplierMutation();
  const [updateSupplier, { isLoading: isUpdating }] =
    useUpdateSupplierMutation();
  const { data: roleList } = useGetRolesQuery({ type: "supplier" });
  const initialFormData = {
    name: "",
    email: "",
    mobile: "",
    gender: "",
    address: "",
    status: 1,
    company_name: "",
    date_of_joining: getCurrentDateTime("YYYY-MM-DDTHH:mm"),
    role_id: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [formErrors, setFormErrors] = useState({});

  // useEffect(() => {
  //   if (mode === "edit" && supplier) {
  //     setFormData({ ...initialFormData, ...supplier });
  //   } else {
  //     setFormData(initialFormData);
  //   }
  // }, [mode, supplier, show]);

  useEffect(() => {
    if (mode === "edit" && supplier) {
      setFormData({
        ...initialFormData,
        ...supplier,
        date_of_joining: supplier?.date_of_joining
          ? convertToUserTimezone(supplier.date_of_joining,"YYYY-MM-DDTHH:mm")
          : "",
      });
    } else {
      setFormData(initialFormData);
    }
  }, [mode, supplier, show]);


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate phone number if provided
    const phoneValidation = validatePhoneNumber(formData.mobile);
    if (formData.mobile && !phoneValidation.isValid) {
      setFormErrors({ mobile: phoneValidation.error });
      return;
    }
    
    setFormErrors({});
    const mutation = mode === "add" ? createSupplier : updateSupplier;    
    try {
      const payload =
        mode === "add" ? formData : { id: supplier.id, requestBody: formData };
      await mutation(payload).unwrap();
      // toast.success(successMessage);
      handleClose();
    } catch (error) {
      // showToast("An error occurred. Please try again later.", "error");
      console.error("Error creating/updating supplier:", error);
    }
  };

  const handleClose = () => {
    setFormErrors({});
    setShow(false);
  };

  const renderFormFields = () => (
    <>
      <Col lg={6}>
        <InputWithLabel
          label={_t("first_name", "First Name")}
          type="text"
          name="first_name"
          value={formData.first_name}
          onChange={handleChange}
          placeholder={_t("supplier_first_name", "Supplier First Name")}
          required
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("last_name", "Last Name")}
          type="text"
          name="last_name"
          value={formData.last_name}
          onChange={handleChange}
          placeholder={_t("supplier_last_name", "Supplier Last Name")}
          required
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("company_name", "Company Name")}
          type="text"
          name="company_name"
          value={formData.company_name}
          onChange={handleChange}
          placeholder={_t("company_name", "Company Name")}
          required
        />
      </Col>
      {/* <Col lg={6}>
        <InputWithLabel
          label={_t("email", "Email")}
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder={_t("email", "Email")}
          required
        />
      </Col> */}
      <Col lg={6}>
        <InputWithLabel
          label={_t("phone_number", "Phone Number")}
          type="mobile"
          name="mobile"
          value={formData.mobile}
          onChange={handleChange}
          placeholder="e.g. +1 202-555-0143"
          required
          error={formErrors.mobile}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("date_of_joining", "Date of Joining")}
          type="datetime-local"
          name="date_of_joining"
          value={formData.date_of_joining}
          onChange={handleChange}
          max={getCurrentDateTime("YYYY-MM-DDTHH:mm")}
          required
        />
      </Col>

      <Col lg={6}>
        <InputWithLabel
          label={_t("address", "Address")}
          type="text"
          name="address"
          value={formData.address}
          onChange={handleChange}
          placeholder={_t("address", "Address")}
          required
        />
      </Col>
      {/* <Col lg={6}>
        <SelectBox
          label={_t("gender", "Gender")}
          name="gender"
          value={formData.gender}
          onChange={handleChange}
          options={[
            { value: "male", label: _t("male", "Male") },
            { value: "female", label: _t("female", "Female") },
          ]}
          required
        />
      </Col> */}
      <Col lg={6}>
        <SelectBox
          label={_t("status", "Status")}
          name="status"
          value={formData.status}
          onChange={handleChange}
          options={[
            { value: 1, label: _t("active", "Active") },
            { value: 0, label: _t("inactive", "Inactive") },
          ]}
          required
        />
      </Col>
      <Col lg={6}>
        <SelectBox
          label={_t("role", "Role")}
          name="role_id"
          value={formData.role_id}
          onChange={handleChange}
          options={roleList?.data.map((list) => ({
            value: list.id,
            label: capitalize(_t(list.name)),
          }))}
          required
        />
      </Col>
    </>
  );

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={
        mode === "add" ? _t("add_supplier", "Add Supplier") : _t("edit_supplier", "Edit Supplier")
      }
    >
      <Row>{renderFormFields()}</Row>
      <Row>
        {" "}
        {/* Moved button to its own row for better layout */}
        <Col className="text-end">
          <Button
            label={
              mode === "add"
                ? _t("add_supplier", "Add Supplier")
                : _t("save_changes", "Save Changes")
            }
            size="small"
            onClick={handleSubmit}
            isLoading={isCreating || isUpdating}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default SupplierModal;
